import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TypeChecker } from '../../../shared/classes/type-checker';
import { BaseControl, Options } from '../../../shared/classes/form-base-controls';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';
import { DropdownControl } from '../../../shared';

@Component({
  selector: 'app-dropdown-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    DropdownModule
  ],
  template: `
    <div [formGroup]="formGroup" *ngIf="typeChecker.isDropdown(control)" class="w-full">
        <p-dropdown [options]="control.displayedOptions" [formControlName]="control.name" 
            optionLabel="text" optionValue="value" 
            autoWidth="true" class="w-full" styleClass="w-full"
            [placeholder]="typeChecker.hasPlaceholder(control) ? control.placeholder : ''"
            [attr.aria-describedby]="control.name + '-help'" 
            [filter]="control.filter" filterBy="text" appendTo="body"
            [virtualScroll]="true" [virtualScrollItemSize]="38"
            [readonly]="control.readonly"
            >                    
        </p-dropdown>
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class DropdownControlComponent implements OnInit {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;

  get controlOptions(): Options<any> {
    return this.control as Options<any>;
  }

  set controlOptions(value: Options<any>) {
    this.control = value;
  }

  constructor(private _tdc: TablasDinamicasConfigService) {    
  }

  ngOnInit(): void {
    /*if (TypeChecker.isDropdown(this.control)) {
      if (this.control.readonly) {
        this.control.FormControl.disable();
      } else {
        this.control.FormControl.enable();
      }
    }*/
    this.getFormularioDataset();
  }

  getFormularioDataset() {
    if (TypeChecker.isDropdown(this.control) && this.control.loadExternalDatasource) {
      this.control.loadExternalDatasource = false;
      this._tdc.getFormularioDataset(this.control.tablaConsulta!, this.control.columnName, this.control.columnValue).subscribe({
        next: (data: Record<string, any>[]) => {
          if (TypeChecker.isDropdown(this.control)) {
            const columnName = this.control.columnName;
            const columnValue = this.control.columnValue;
            const currentValue = this.control.FormControl.value;
            this.controlOptions.options = [];

            data.forEach((item: Record<string, any>) => {
              this.controlOptions.options.push({
                value: item[columnValue],
                text: item[columnName],
                ...item
              });
            });
            //Aplicar el valor actual si existe , el valor se borra cuando las options se reinician         
            if (currentValue) {
              this.control.FormControl.setValue(currentValue);
            }
          }
        }
      });
    }
  }
}
